<div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 sm:justify-start sm:gap-6">
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white/90">Settings</h2>
        <nav>
            <ol class="flex items-center gap-1.5">
                <li>
                    <a routerLink="/" class="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400" href="/">
                        Home
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-current">
                            <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke="" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </a>
                </li>
                <li class="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
                    <a routerLink="/dashboard/setting">Settings</a>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-current">
                        <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke="" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </li>
                <li class="text-sm text-gray-800 dark:text-white/90">Preferences</li>
            </ol>
        </nav>
    </div>
</div>

<div class="space-y-6">
    <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
            <h2 class="text-lg font-medium text-brand-500 dark:text-white">Preferences</h2>
        </div>

        <div class="p-4 sm:p-6 dark:border-gray-800">

            <!-- Gender / Attracted To -->
            <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 mb-6">
                <div>
                    <app-lable for="pref-gender">Gender</app-lable>
                    <app-select [options]="genderOptions" [ngModel]="preferencesService.draft.gender" (ngModelChange)="onGenderChange($event)"
                        name="gender" placeholder="Select Gender" className="dark:bg-dark-900">
                    </app-select>
                </div>

                <div class="attracted-to-wrapper relative">
                    <app-lable for="pref-attracted-to">Attracted To</app-lable>
                    <button type="button" (click)="toggleAttractedToDropdown($event)"
                        class="relative min-h-11 w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 pr-11 text-sm text-left shadow-theme-xs focus:border-brand-300 focus:outline-none focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:focus:border-brand-800 transition-colors"
                        [class.border-brand-300]="attractedToDropdownOpen">
                        <span *ngIf="preferencesService.draft.attractedTo.length === 0" class="text-gray-400 dark:text-gray-500">Select Attracted To</span>
                        <span *ngIf="preferencesService.draft.attractedTo.length > 0" class="flex flex-wrap gap-1.5">
                            <span *ngFor="let val of preferencesService.draft.attractedTo"
                                class="inline-flex items-center gap-1 rounded-full bg-brand-50 px-2.5 py-1 text-xs font-medium text-brand-600 dark:bg-brand-500/10">
                                {{ val }}
                                <span (click)="$event.stopPropagation(); removeAttractedTo(val)" class="cursor-pointer text-brand-400 hover:text-brand-600">&times;</span>
                            </span>
                        </span>
                        <svg class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500 dark:text-gray-400 transition-transform duration-200"
                            [class.rotate-180]="attractedToDropdownOpen" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M4.79175 8.02075L10.0001 13.2291L15.2084 8.02075" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <div *ngIf="attractedToDropdownOpen"
                        class="absolute z-50 left-0 right-0 mt-1 rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900 overflow-hidden">
                        <ul class="py-1 max-h-56 overflow-y-auto">
                            <li *ngFor="let opt of attractedToOptions"
                                (click)="toggleAttractedTo($event, opt.value)"
                                role="checkbox" [attr.aria-checked]="isAttractedToSelected(opt.value)"
                                class="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer select-none transition-colors duration-100"
                                [class.bg-brand-50]="isAttractedToSelected(opt.value)"
                                [class.text-brand-600]="isAttractedToSelected(opt.value)"
                                [class.text-gray-700]="!isAttractedToSelected(opt.value)">
                                <span class="flex h-4 w-4 flex-shrink-0 items-center justify-center rounded border transition-colors"
                                    [ngClass]="isAttractedToSelected(opt.value)
                                        ? 'border-brand-500 bg-brand-500'
                                        : 'border-gray-300 bg-transparent dark:border-gray-600'">
                                    <svg *ngIf="isAttractedToSelected(opt.value)" class="text-white" width="12" height="12" viewBox="0 0 16 16" fill="none">
                                        <path d="M3 8L6.5 11.5L13 4.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <span>{{ opt.label }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- The 8 multi-select preference categories -->
            <div class="rounded-xl border border-gray-100 dark:border-gray-800 overflow-hidden">
                <div class="hidden sm:grid sm:grid-cols-[1fr_auto_auto] gap-4 px-4 py-2 bg-gray-50 dark:bg-white/5 text-xs font-semibold text-gray-400 uppercase tracking-wide">
                    <span></span>
                    <span></span>
                    <span class="text-right">Show on Profile?</span>
                </div>

                <div *ngFor="let cat of categories; let last = last"
                    class="grid grid-cols-1 sm:grid-cols-[1fr_auto_auto] gap-3 sm:gap-4 items-center px-4 py-4"
                    [class.border-b]="!last" [class.border-gray-100]="!last" [class.dark:border-gray-800]="!last">

                    <div class="min-w-0">
                        <p class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ cat.label }}</p>
                        <p *ngIf="chipsSummary(cat)" class="text-xs text-gray-400 mt-0.5 truncate">{{ chipsSummary(cat) }}</p>
                        <p *ngIf="!chipsSummary(cat)" class="text-xs text-gray-400 mt-0.5">Nothing selected yet</p>
                    </div>

                    <button type="button" (click)="openCategory(cat)"
                        class="justify-self-start sm:justify-self-auto rounded-lg bg-gray-800 dark:bg-gray-700 px-4 py-2 text-xs font-semibold text-white hover:bg-gray-900 dark:hover:bg-gray-600 transition-colors whitespace-nowrap">
                        Select
                    </button>

                    <label class="flex items-center gap-2 justify-self-start sm:justify-self-end cursor-pointer select-none">
                        <span class="text-xs text-gray-500 dark:text-gray-400 sm:hidden">Show on Profile?</span>
                        <input type="checkbox" [checked]="visibilityFor(cat)" (change)="toggleRowVisibility(cat, $event)"
                            class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-800">
                    </label>
                </div>
            </div>

            <!-- Changes are saved automatically — no Update button needed. -->
            <div class="mt-6 flex items-center justify-end gap-3 border-t border-gray-200 pt-5 text-sm dark:border-gray-800" aria-live="polite">
                <ng-container [ngSwitch]="saveStatus">
                    <span *ngSwitchCase="'saving'" class="inline-flex items-center gap-2 text-gray-500 dark:text-gray-400">
                        <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" class="opacity-25"></circle>
                            <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                        Saving…
                    </span>
                    <span *ngSwitchCase="'saved'" class="inline-flex items-center gap-2 text-success-600 dark:text-success-500">
                        <svg class="h-4 w-4" viewBox="0 0 16 16" fill="none">
                            <path d="M3 8L6.5 11.5L13 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        All changes saved
                    </span>
                    <span *ngSwitchCase="'error'" class="inline-flex items-center gap-3 text-error-600 dark:text-error-500">
                        Couldn't save your changes.
                        <button type="button" (click)="retrySave()" class="font-semibold underline">Retry</button>
                    </span>
                    <span *ngSwitchDefault class="text-gray-400">Changes are saved automatically</span>
                </ng-container>
            </div>

        </div>
    </div>
</div>
